import {HyperlinkEngine} from "../utilities/HyperlinkEngine";

const currentUrl = HyperlinkEngine.currentUrl;

function findParentRoute(linkElement) {
    const parentCurrentPath = decodeURI(currentUrl.pathname).split('/').filter(e => e !== '' && e !== 'el').at(0);
    if (decodeURI(linkElement.pathname).split('/').filter(e => e !== '' && e !== 'el').join('') === parentCurrentPath) {
        // console.log(linkElement)
    }
}

/**
 *
 * @param list
 * @type  NodeListOf<HTMLElementTagNameMap[string]>
 * @return {HTMLLinkElement[]}
 */
function filterLinkElements(list) {
    return [...list]
        .filter(link =>
            !link.classList.contains('navbar__brand')
            && !HyperlinkEngine.isHash(link)
            && !HyperlinkEngine.isDropdown(link)
            && !HyperlinkEngine.isTargetBlank(link)
        );
}

/**
 *
 * @param element {HTMLElement}
 * @return {void}
 */
function setAncestorLinkState(element) {
    const closestAncestorElement = element.closest('.nav-dropdown');
    if (closestAncestorElement === null) return;
    HyperlinkEngine.activate(closestAncestorElement.querySelector('a[data-type="nav-dropdown"]'));
}

export default function useRouterActive() {
    for (const link of filterLinkElements(document.querySelectorAll('a'))) {
        findParentRoute(link);
        const currentUrl = new URL(window.location);
        const targetUrl = new URL(link.href);
        if (targetUrl.pathname === currentUrl.pathname) {
            setAncestorLinkState(link); // in case of nested routes
            HyperlinkEngine.activate(link); // exact active link
        }
    }
}
